// extracted by css-extract-rspack-plugin
export default {"container":"LZWJhzcpNVgqc7Y8"};